import { useEffect, useState } from "react";
import { Alert, Linking } from "react-native";
import { getEnv } from "../helpers/general";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { HomePageAppInfoType } from "../types/server";

export function useForceUpdate(data: HomePageAppInfoType) {
  const ANDROID_VERSION_CODE = getEnv("ANDROID_VERSION_CODE");
  const ANDROID_APP_ID = getEnv("ANDROID_APP_ID");
  let [versionStatus, setVersionStatus] = useState("");

  useEffect(() => {
    AsyncStorage.getItem("updateApp").then((res) => {
      if (res) {
        setVersionStatus(res);
      } else {
        setVersionStatus("now");
      }
    });
  }, [versionStatus]);

  useEffect(() => {
    if (
      !!versionStatus &&
      versionStatus === "later" &&
      Number(data?.max_version) === Number(ANDROID_VERSION_CODE)
    ) {
      AsyncStorage.setItem("updateApp", "updated");
    }
    if (!!data?.required_version) {
      if (Number(ANDROID_VERSION_CODE) !== Number(data?.required_version)) {
        Alert.alert(
          "بروزرسانی",
          "نسخه جدیدی از اپلیکیشن دیجی‌واش در دسترس است. لطفا بروزرسانی کنید.",
          [
            {
              text: "بروزرسانی",

              onPress: () => {
                Linking.openURL("bazaar://details?id=" + ANDROID_APP_ID);
              },
            },
          ],
          { cancelable: false }
        );
      }
    } else if (!!versionStatus && versionStatus !== "later") {
      if (
        Number(data?.max_version) > Number(ANDROID_VERSION_CODE) &&
        Number(ANDROID_VERSION_CODE) > Number(data?.min_version)
      ) {
        Alert.alert(
          "بروزرسانی",
          "نسخه جدیدی از اپلیکیشن دیجی‌واش در دسترس است. لطفا بروزرسانی کنید.",
          [
            {
              text: "بستن",
              style: "cancel",
            },
            {
              text: "بعدا بروزرسانی میکنم",
              onPress: () => {
                AsyncStorage.setItem("updateApp", "later");
              },
            },
            {
              text: "بروزرسانی",
              onPress: () => {
                Linking.openURL("bazaar://details?id=" + ANDROID_APP_ID);
              },
            },
          ],
          { cancelable: false }
        );
      } else if (Number(ANDROID_VERSION_CODE) < Number(data?.min_version)) {
        Alert.alert(
          "بروزرسانی",
          "نسخه اپلیکیشن شما منقضی شده است. لطفا بروزرسانی کنید.",
          [
            {
              text: "بروزرسانی",
              onPress: () => {
                Linking.openURL("bazaar://details?id=" + ANDROID_APP_ID);
              },
            },
          ],
          { cancelable: false }
        );
      }
    }
  }, [versionStatus, data]);
}
